import type {
    WorkOrderSeasonData,
    WorkOrderSeasonTotalData,
    WorkOrderTotalData,
    WorkOrderVersionSeasonData,
} from 'gql/graphql';
import { formatNumberToRu } from 'utils';

import type { ColDef } from 'ag-grid-community';
import type { CellClassParams, ValueFormatterParams } from 'ag-grid-community/dist/types/core/entities/colDef';

type TSeasonValueGetter = {
    id: number;
    key: keyof WorkOrderSeasonTotalData;
    costRounding: number;
};

type TSeasonColumn = {
    seasons: (WorkOrderSeasonData | WorkOrderVersionSeasonData)[];
    name: string;
    costRounding: number;
    valueKey: keyof WorkOrderSeasonTotalData;
};

export const cellClass = (cellClassParams: CellClassParams<WorkOrderTotalData>) => {
    const headLineClass = cellClassParams.data?.isHeadLine ? 'head-line' : 'ordinary-line';

    return cellClassParams.colDef.field === 'name' ? [headLineClass] : [headLineClass, 'ag-right-aligned-cell'];
};

export const getSeasonValueByIdAndKey =
    ({ key, costRounding, id }: TSeasonValueGetter) =>
    ({ data }: { data: WorkOrderTotalData }) => {
        const currentSeason = data?.seasonTotals?.find((season) => season.seasonId === id);

        return formatNumberToRu(currentSeason?.[key], costRounding) ?? '';
    };

export const getSeasonColumns = ({ seasons, valueKey, costRounding, name }: TSeasonColumn): ColDef[] =>
    seasons.map((season) => ({
        headerName: `Сезон ${season.year}, ${name}`,
        flex: 1,
        type: 'numericColumn',
        minWidth: 200,
        cellClass,
        valueGetter: getSeasonValueByIdAndKey({
            id: season.id,
            key: valueKey,
            costRounding,
        }),
    }));

export const getFormattedValue =
    (costRounding: number) =>
    ({ value }: ValueFormatterParams) =>
        formatNumberToRu(value, costRounding) ?? '';
